import { Grid, Typography } from "@mui/material"
import { FieldValues, UseFormReturn } from "react-hook-form"
import { ActionCard } from "../../../../../components/widgets/ActionCard";
import { Calculate } from "@mui/icons-material";
import { col4 } from "../../../../../common/utils";
import logo from "../../../../../../src/assets/logo.svg";
import { useTranslation } from "react-i18next";



interface Props<T extends FieldValues> {
    form: UseFormReturn<T>;
    handleNext: VoidFunction;
}

export const CalcType = ({ form, handleNext }: Props<any>) => {

    const { t } = useTranslation("dataCollection");

    const handleSelectCalcType = (calcType: 'greenrouter' | 'other') => {
        form.setValue('calcType', calcType);
        handleNext();
    }

    return (
        <>
            <Grid size={12}>
                <Typography variant="h5" fontWeight={400} textAlign='center'>
                    {t("import/select calculation type")}
                </Typography>
            </Grid>
            <Grid size={12} container justifyContent="center" spacing={2}>
                <Grid size={col4}>
                    <ActionCard
                        icon={<img width={48} src={logo} alt="green-router-logo" />}
                        title={t("import/greenrouter")}
                        onClick={() => handleSelectCalcType('greenrouter')}
                    />
                </Grid>
                <Grid size={col4}>
                    <ActionCard
                        icon={<Calculate color="action" sx={{fontSize: '48px'}} />}
                        title={t("import/other")}
                        onClick={() => handleSelectCalcType('other')}
                    />
                </Grid>
            </Grid>
        </>
        
    )
}